
import React from 'react';
import axios from 'axios';
import $ from 'jquery';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory from 'react-bootstrap-table2-filter';
import { getSessionID, getSessionName, getCompanyID } from '../../../../../Utils/Common';
import AddShiftAssignments from './addShiftAssignments';

class PayrollUserShiftAssignments extends React.Component {
  constructor () {
      super();

      this.state = {
        tableData:[]
      };
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }

    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }

    
    axios.get('http://payroll.nikkolim.com/get_shift_assignments/shift_assignments_company/'+company_id, {
    headers: {
      'Content-Type': 'application/json',
      "Authentication": session_Name+"="+session_ID,
    }
  })
  .then((response) => {
    const data = [];
    $.each( response.data, function( i, val ) {   
        //console.log(JSON.stringify(val));
      $.each(val, function( i, val2 ){
        data.push(val2.attributes);
        self.setState({
            tableData: data
        });
        //console.log(JSON.stringify(data));
      })
      
    });
    //console.log(JSON.stringify(response.data));
  }, (error) => {
    console.log(error);
  });
  
  }

//   valueFormatter(cell, row){
//     return (
//       <div><a className="btn btn-primary" href={"employees-details/"+cell}>View Details</a></div>
//       );
//   }

  render () {
      const { tableData } = this.state;
      const textfilter = { type: 'TextFilter', delay: 1000};
      const datefilter = { type: 'DateFilter', delay: 1000};

      let datalist = [{
        dataField: 'field_assignment_label',
        text: 'Label',
      },{
        dataField: 'field_assignment_start_date',
        text: 'From (Date)'
      },{
        dataField: 'field_assignment_end_date',
        text: 'To (Date)'
      },{
        ataField: 'field_assignment_department',
        text: 'Department'
      },{
        ataField: 'field_assignment_group',
        text: 'Group'
      },{
        ataField: 'field_assignment_employee_type',
        text: 'Employee Type'
      },{
        dataField: 'entity_id',
        text: 'ID'
      }];
      
      return (
        
      <div>
        <h1 class="h3 mb-0 text-gray-800">Shift Assignments</h1>
        <div className="add-button"><AddShiftAssignments></AddShiftAssignments></div>
        <BootstrapTable responsive wrapperClasses='table-responsive' bootstrap4 version='4' keyField='entity_id' filter={ filterFactory() } columns={ datalist } data={ tableData } pagination={ paginationFactory() } search>
          <TableHeaderColumn dataSort dataField='field_assignment_label' filter={textfilter}>Label</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_assignment_start_date' filter={datefilter}>From (Date)</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_assignment_end_date' filter={datefilter}>To (Date)</TableHeaderColumn>
          <TableHeaderColumn dataField='field_assignment_department'filter={textfilter} >Department</TableHeaderColumn>
          <TableHeaderColumn dataField='field_assignment_group' filter={textfilter}>Group</TableHeaderColumn>
          <TableHeaderColumn dataField='field_assignment_employee_type' filter={textfilter}>Employee</TableHeaderColumn>
        </BootstrapTable>
      </div>  
      );
  }
};



export default PayrollUserShiftAssignments;

